import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=ac1edb38&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=ts&"
export * from "./PersonDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PersonDetails.vue?vue&type=style&index=0&id=ac1edb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1edb38",
  null
  
)

export default component.exports